import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ListProduct } from '@shabic/models';

@Component({
  selector: 'shabic-product-client-actions',
  templateUrl: './product-client-actions.component.html',
  styleUrls: ['./product-client-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductClientActionsComponent {
  @Input() product!: ListProduct;
  @Output() request: EventEmitter<void> = new EventEmitter();

  onRequest(): void {
    this.request.emit();
  }
}
